import CryptoJS from 'crypto-js';

const keySize = 256;
const ivSize = 128;
const saltSize = 256;
const iterations = 1000;
const password = "Int3rr4p1d1s1m0Cl4S33ncr1pc10nPt2022";

// Helper functions
const hexToBase64 = (str: any): string => {
    return btoa(String.fromCharCode.apply(null, str.replace(/\r|\n/g, "").replace(/([\da-fA-F]{2}) ?/g, "0x$1 ").replace(/ +$/, "").split(" ")));
};

const base64ToHex = (str: string): string => {
    const bin = atob(str.replace(/[ \r\n]+$/, ""));
    const hex: string[] = [];
    for (let i = 0; i < bin.length; ++i) {
        let tmp = bin.charCodeAt(i).toString(16);
        if (tmp.length === 1) tmp = "0" + tmp;
        hex.push(tmp);
    }
    return hex.join("")
}

const encrypt = (guide: string, password: string): string => {
    const salt = CryptoJS.lib.WordArray.random(saltSize / 8);
    const key = CryptoJS.PBKDF2(password, salt, {
        keySize: keySize / 32,
        iterations: iterations,
    });
    const iv = CryptoJS.lib.WordArray.random(ivSize / 8);
    const encrypted = CryptoJS.AES.encrypt(guide, key, {
        iv: iv,
        padding: CryptoJS.pad.Pkcs7,
        mode: CryptoJS.mode.CBC,
    });

    return hexToBase64(salt.toString() + iv.toString() + base64ToHex(encrypted.toString()));
};

const redirectGuide = (guide: string): string => {
    const url = "https://www3.interrapidisimo.com/SiguetuEnvio/shipment/";
    const guideEncrypt = encrypt(guide, password);

    const urlEncode = url + encodeURIComponent(guideEncrypt).replace(/%/g, "_");

   return urlEncode
};

export {redirectGuide}
